import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      component: resolve => require(['@/page/index.vue'], resolve),
    },
    {
      path: '/index',
      component: resolve => require(['@/page/index.vue'], resolve),
    },
    {
      path: '/my',
      component: resolve => require(['@/page/my.vue'], resolve),
    },
    {
      path: '/country',
      component: resolve => require(['@/page/country.vue'], resolve),
    },
    {
      path: '/visa_data',
      component: resolve => require(['@/page/visa_data.vue'], resolve),
    },
    {
      path: '/login',
      component: resolve => require(['@/page/login.vue'], resolve),
    },
    {
      path: '/filelist',
      component: resolve => require(['@/page/filelist.vue'], resolve),
    },
    {
      path: '/info',
      component: resolve => require(['@/page/info.vue'], resolve),
    },
    {
      path: '/about',
      component: resolve => require(['@/page/about.vue'], resolve),
    },
    {
      path: '/agreement',
      component: resolve => require(['@/page/agreement.vue'], resolve),
    },
    {
      path: '/address',
      component: resolve => require(['@/page/address.vue'], resolve),
    },
    {
      path: '/application',
      component: resolve => require(['@/page/application.vue'], resolve),
    },
    {
      path: '/order_detail',
      component: resolve => require(['@/page/order_detail.vue'], resolve),
    },
    {
      path: '/electronic',
      component: resolve => require(['@/page/electronic.vue'], resolve),
    },
    {
      path: '/upload_many',
      component: resolve => require(['@/page/upload_many.vue'], resolve),
    },
    {
      path: '/upload_single',
      component: resolve => require(['@/page/upload_single.vue'], resolve),
    },
    {
      path: '/order',
      component: resolve => require(['@/page/order.vue'], resolve),
    },
    {
      path: '/order_compose',
      component: resolve => require(['@/page/order_compose.vue'], resolve),
    },
    {
      path: '/applicant',
      component: resolve => require(['@/page/applicant.vue'], resolve),
    },
    {
      path: '/application_list',
      component: resolve => require(['@/page/application_list.vue'], resolve),
    },
    {
      path: '/electronic_list',
      component: resolve => require(['@/page/electronic_list.vue'], resolve),
    },
    {
      path: '/order_read',
      component: resolve => require(['@/page/order_read.vue'], resolve),
    },
    {
      path: '/select',
      component: resolve => require(['@/page/select.vue'], resolve),
    },
    {
      path: '/pic_detail',
      component: resolve => require(['@/page/pic_detail.vue'], resolve),
    },
    {
      path: '/supplement',
      component: resolve => require(['@/page/supplement.vue'], resolve),
    },
    {
      path: '/banner_data',
      component: resolve => require(['@/page/banner_data.vue'], resolve),
    },
    {
      path: '/single_country',
      component: resolve => require(['@/page/single_country.vue'], resolve),
    },
    {
      path: '/envelope',
      component: resolve => require(['@/page/envelope.vue'], resolve),
    },
    {
      path: '/select_applicant',
      component: resolve => require(['@/page/select_applicant.vue'], resolve),
    },

    
    
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js